import { Page } from '@touche-lts/panel-ui/dist'
import { FetchOptions } from 'services'
import { PaginationSearchBase } from '..'
import { ActionHistoryTableSearchProps, ActionHistoryTableSortProps } from './action-history-table-base.types'
import {
    initialActionHistoryTablePaginationProps, 
    initialActionHistoryTableSearchProps, 
    ordersNeedTimeoutProps
} from './action-history-table-base.utils'

export class ActionhistoryTableBase extends PaginationSearchBase<
    ActionHistoryTableSortProps,
    ActionHistoryTableSearchProps,
    any
> {
  constructor () {
    super({
        initialPaginationProps: initialActionHistoryTablePaginationProps,
        initialSearchProps: initialActionHistoryTableSearchProps,
        needTimeoutProps: ordersNeedTimeoutProps
      })
  }

  public handleSearchResult = (data: Page<any>): void => {
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  public getPageQueryParams = (
    resetPageNumber: boolean
  ): FetchOptions['pageQueryParams'] => {
    return {
      page: resetPageNumber ? 0 : this.pagination.page,
      size: this.pagination.size,
      sortDirection: this.pagination.sortDirection,
      sortProp: this.pagination.sortProp
    }
  }

  public get ordersFilter (): Partial<ActionHistoryTableSearchProps> {
    return {
      actionType: this.searchProps.actionType,
      changes: !!this.searchProps.changes ? [this.searchProps.changes] : [],
      entityTitle: !!this.searchProps.entityTitle ? this.searchProps.entityTitle : null,
      periodFrom: this.searchProps.orderDate
      ? this.searchProps.orderDate.start.toISOString()
      : null,
      periodTo: this.searchProps.orderDate
      ? this.searchProps.orderDate.end.toISOString()
      : null
    }
  }
}
